import { useMemo } from "react";
import { useCapabilities } from "../../../hooks/useCapabilities";
import { Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";

export interface StakeHolder {
  full_name: string;
  email: string;
  id: number;
  project_id: number;
  user_id: number;
  role: string;
  is_active: boolean;
  role_id: number;
  is_archived: boolean;
  created_by: string;
  created_date: string;
  approver: null | any;
  is_ownership_available: boolean;
}

interface UseStakeHolderActionsProps {
    setIsDeleteStakeHolder: React.Dispatch<React.SetStateAction<{
        status: boolean;
        stakeHolderDetails: StakeHolder | null;
    }>>;
    setIsReassignStakeHolder: React.Dispatch<React.SetStateAction<
        {
            status: boolean;
            stakeHolderDetails: StakeHolder | null;
        }
    >>;
}

export const useStakeHolderActions = ({ setIsDeleteStakeHolder, setIsReassignStakeHolder }: UseStakeHolderActionsProps) => {

  const renderIconWithTooltip = (
    Icon: React.ElementType,
    tooltipTitle: string,
    isDisabled: boolean
  ) => {
    return (
      <Tooltip title={tooltipTitle}>
        <span
          style={{
          display: "inline-flex",
          cursor: "pointer",
          opacity: isDisabled ? 0.4 : 1,
          pointerEvents: "auto",
        }}
        >
          <Icon/>
        </span>
      </Tooltip>
    )
    }

    const { isAllowedToDeleteStakeHolder, isAllowedToReassignStakeHolder } = useCapabilities();
    
    const actions = useMemo(() => {
    const result: any[] = [];

    // DELETE ACTION
    if (isAllowedToDeleteStakeHolder) {
      result.push({
        label: (row: StakeHolder) => (
            renderIconWithTooltip(
              DeleteIcon,
              row.is_ownership_available
                ? "The stakeholder has been assigned to tasks, reassign them to a different stakeholder before deleting."
                : "Delete Stakeholder",
              row.is_ownership_available
            )
        ),
        isDisable: (row: StakeHolder) => row.is_ownership_available,
        handleClick: (row: StakeHolder) => {
          if (!row.is_ownership_available) {
            setIsDeleteStakeHolder({
              status: true,
              stakeHolderDetails: row,
            });
          }
        },
      });
    }

    // REASSIGN ACTION
    if (isAllowedToReassignStakeHolder) {
      result.push({
        label: (row: StakeHolder) => (
          renderIconWithTooltip(
            AssignmentReturnIcon,
            !row.is_ownership_available ? "No tasks are assigned to this stakeholder" : "Reassign tasks",
            !row.is_ownership_available
          )
        ),
        isDisable: (row: StakeHolder) => !row.is_ownership_available,
        handleClick: (row: StakeHolder) => {
          if (row.is_ownership_available) {
            setIsReassignStakeHolder({
              status: true,
              stakeHolderDetails: row,
            });
          }
        },
      });
    }

    return result;
  }, [
    isAllowedToDeleteStakeHolder,
    isAllowedToReassignStakeHolder,
    setIsDeleteStakeHolder,
    setIsReassignStakeHolder,
  ]);

    return actions;
};